import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

let isMounted = false;

export const DevtoolsWrapper = () => {
  useEffect(() => {
    isMounted = true;
  }, []);

  if (isMounted) return null;

  return createPortal(
    <ReactQueryDevtools initialIsOpen={false} panelPosition="bottom" />,
    document.body,
  );
};

const ReactQueryProvider = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <DevtoolsWrapper />
    {children}
  </QueryClientProvider>
);

export { queryClient, ReactQueryProvider };
